module.exports = __webpack_public_path__ + "img/scb-easy.55aacd05.svg";